import React from 'react'
import { UserPlus,UserCheck } from 'react-feather';
import New from '../../assets/icons/new.svg'
import InProgress from '../../assets/icons/in-progress.svg'
import ReachedPickup from '../../assets/icons/reached_pickup.svg'
import VendorAssigned from '../../assets/icons/vendor_assigned.icon.svg'

const StatusIcons = ({statusType}) => {
    let icon;
    switch (statusType){
        case 'New':
            icon= <img src={New} alt="Your SVG" />
            break;
        case 'InProgress':
            icon= <img src={InProgress} alt="Your SVG" />
            break;
        case 'ForManualAssignment':
            icon=<UserPlus className='assignment-icon'/>
            break;
        case 'InBidding':
            icon=<i className="icofont icofont-order"></i>
            break;
        case "Assigned":
            icon=<UserCheck className='assigned-icon'/>
            break;
        case "Confirmed":
            icon=<UserCheck className='assigned-icon'/>
            break;
        case 'ReachedPickup':
            icon=<img src={ReachedPickup} alt="Your SVG" />
            break;
        case "Cancelled":
            icon=<i className="fa fa-times-circle-o"></i>
            break;
        case "Completed":
            icon=<i className="fa fa-check-circle-o"></i>
            break;
        case "Complete":
            icon=<i className="fa fa-check-circle-o"></i>
            break;
        case "VendorAssigned":
            icon = <img src={VendorAssigned} style={{width:"2.4vw", height:"2.4vw"}} alt="Your SVG" />
            break;
        default:
            icon='-'
    }
  return icon
}

export default StatusIcons